import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-form-title-with-subtitle',
  imports: [],
  templateUrl: './form-title-with-subtitle.component.html',
  styleUrl: './form-title-with-subtitle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTitleWithSubtitleComponent {}
